import React from "react";
import { Link } from "react-router-dom";
import UseLang from "../../../hooks/UseLang";

function AnalisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1Preview() {
  return (
    <>
      <UseLang es>
        <div>
          <div>
            <h1>Análisis de funcionamiento del Trust Anchor (TA) de RPKI</h1>
            <p>
              Autor: ERIKA VEGA - CHAIR GRUPO DE TRABAJO ENRUTAMIENTO LACNOG
            </p>

            <p>Coordinación: GUILLERMO CICILEO (LIDER DE I+D LACNIC)</p>

            <p>Área: I+D EN INFRAESTRUCUTURA DE INTERNET</p>

            <p>Fecha: 01/11/2025</p>
            <Link
              className="buttons button_blue"
              to="/es/interconexion/analisis-de-funcionamiento-del-trust-anchor-ta-de-rpki"
            >
              Leer Reporte
            </Link>
          </div>{" "}
        </div>
      </UseLang>
      <UseLang en>
        <div>
          <div>
            <h1>Analysis of the Operation of RPKI Trust Anchors</h1>
            <p>
              Author: ERIKA VEGA, CHAIR OF THE LACNOG ROUTING WORKING GROUP
            </p>
            <p>Coordination: GUILLERMO CICILEO, HEAD OF R&D AT LACNIC</p>
            <p>Area: INTERNET INFRASTRUCTURE R&D</p>
            <p>Date: 01/11/2025</p>
            <Link
              className="buttons button_blue"
              to="/en/interconnection/analysis-of-the-operation-of-rpki-trust-anchors"
            >
              Read Report
            </Link>
          </div>
        </div>
      </UseLang>
      <UseLang pt>
        <div>
          <div>
            <h1>Análise do funcionamento do Trust Anchor (TA) do RPKI</h1>
            <p>
              Autor: ERIKA VEGA – CHAIR GRUPO DE TRABALHO ROTEAMENTO LACNOG
            </p>
            <p>COORDENAÇÃO: GUILLERMO CICILEO (LÍDER DE P&D LACNIC)</p>
            <p>Área: P&D NA INFRAESTRUTURA DA INTERNET</p>
            <p>Data: 01/11/2025</p>
            <Link
              className="buttons button_blue"
              to="/pt/interconexao/analise-do-funcionamento-do-trust-anchor-ta-do-rpki"
            >
              Leia o Relatório
            </Link>
          </div>
        </div>
      </UseLang>
    </>
  );
}

export default AnalisisDeFuncionamientoDelTrustAnchorTaDeRpkiV1Preview;
